<script>
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}

<h4>起卦</h4>
<h5>自己輸入起卦結果</h5>

無論您用大衍筮法或是金錢卦法，起卦之後都會得到六個 6 ～ 9 的數字，形成一卦。
您可以自行輸入您的問題、得到的六個爻數、起卦日期，在您的帳戶裡加入您的卦例。
輸入之後，您可以看到所有卦象、卦辭，也可以隨即加入您的解卦心得。
您也可以隨時到卦例的部分去複習、增加筆記，並且可以連結自己其他相關卦例，增加理解。

<h5>整批卦例上傳</h5>

如果您已經有了許多卦例，您也可以整理出來成一個固定格式的文檔，整批上傳。需要的話，請點擊這裡：<a href="">詳細說明</a>

<h5>電腦自動起卦</h5>

請注意！【XiYi 習易網】所提供的自動起卦功能是為了幫助會員方便習易，作為參考而已，不是為了算命！請千萬不要迷信！

在學習易經的進程裡，我試過金錢卦和大衍占法。不管是哪一種起卦的方法，
操作起來，總要花個十幾、二十分鐘。所以，我遇到的第一個困難就是，每當我有想要起卦的念頭的時候，卻很難碰又安靜、又不受打擾的時間段。
第二，就算碰上了好的起卦時機，我也很難在十幾、二十分鐘操作起卦的過程中，一直保持定心、定意、不被打擾。有趣的是，即使如此，
我占到的卦大多都還是有參考價值。不過，這些實際上的操作困難還是經常困擾著我。

網路上各種各樣有關電腦算命程式和服務很多，我以前從來都不愛去看。自從較用功學習易經以來，
我發現我還真的需要有個電腦起卦的程式來幫我。電腦起一卦，不用一秒鐘。我起卦的心總是誠懇的，就算人在機場、捷運，把心意安定個一、兩分鐘我也應該做得到。如果能夠有個有個我覺得**信得過**的起卦程式，那該有多好！自然，我還沒有找到合用的，不然我也不會自己做一個。

要特別強調的是：這裡我並沒有說別家的起卦程式不好的意思，反而，有些很可能是非常好的設計。其實，大概是我自己的職業病吧：我不了解、也無從得知人家是怎麼做的，因而信不過。換句話說，就是沒有「孚」，於是自然對我個人不「亨」。

我個人是學習電腦工程出身，又在高科技產業打滾大半輩子，我理解真正的隨機亂數產生不易。
既然決定自己寫一個起卦程式，我首先花了點時間設計了一個加入多項起卦人因子的「大概夠隨機」的亂數算法，
再模擬人手操作大衍占法的動作，做出了這個電腦起卦程式。經過了好幾次更改、調整參數，
電腦模擬計算數百萬次，確定各爻出現的機率接近理論值，各卦的出現也都成合理分佈，也就是現在的這個版本（2021v005）。
下圖是 2021v005 模擬計算 200000 次的結果統計：

<img class="yao-stat" src="./images/autoqi_v005.png" alt="qua stat" />

在我確定模擬計算結果穩定、而且統計分佈合理可接受之後，我用它自動起了一卦，得【火天大有】4 爻動：【九四】：匪其彭，无咎。
【象】：匪其彭，无咎，明辨皙也。看來好像還行，我對它有了初步的信心。既然在技術方面確定了隨機合理分佈，
我想，剩下的變數大概就是起卦人本身在起卦時的心意了。

第二天一大早，趁著家人還沒起床，在餐桌上，我自己又用傳統大衍占法，問：
「XiYi
自動起卦版本 2021v005 占卦的結果品質可信嗎？」，得不變的【水地比】，卦辭：吉，原筮，元永貞，无咎。不寧方來，後夫凶。
我感到非常驚訝和有趣！除了【比卦】六爻全變就正好是昨晚自動起卦得到的【火天大有】，而易經 64 卦裡又只有【山水蒙】和【水地比】兩卦提到「筮」。
看來要把握初心真實誠懇為要，於是我的信心更為增加。

用了一陣子之後，得到許多驚喜，我覺得這的確是可以幫助我學習易經的工具。
當然，這是我個人的經驗，現在，我對它有「孚」。歡迎您試試，看合不合您使用？也再度提醒您：千萬不要迷信！

{:else }

<h4>起卦</h4>
<h5>自己输入起卦结果</h5>

无论您用大衍筮法或是金钱卦法，起卦之后都会得到六个 6 ～ 9 的数字，形成一卦。
您可以自行输入您的问题、得到的六个爻数、起卦日期，在您的帐户里加入您的卦例。
输入之后，您可以看到所有卦象、卦辞，也可以随即加入您的解卦心得。
您也可以随时到卦例的部分去复习、增加笔记，并且可以连结自己其他相关卦例，增加理解。

<h5>整批卦例上传</h5>

如果您已经有了许多卦例，您也可以整理出来成一个固定格式的文档，整批上传。需要的话，请点击这里：<a href="">详细说明</a>

<h5>电脑自动起卦</h5>

请注意！【XiYi 习易网】所提供的自动起卦功能是为了帮助会员方便习易，作为参考而已，不是为了算命！请千万不要迷信！

在学习易经的进程里，我试过金钱卦和大衍占法。不管是哪一种起卦的方法，
操作起来，总要花个十几、二十分钟。所以，我遇到的第一个困难就是，每当我有想要起卦的念头的时候，却很难碰又安静、又不受打扰的时间段。
第二，就算碰上了好的起卦时机，我也很难在十几、二十分钟操作起卦的过程中，一直保持定心、定意、不被打扰。有趣的是，即使如此，
我占到的卦大多都还是有参考价值。不过，这些实际上的操作困难还是经常困扰著我。

网路上各种各样有关电脑算命程式和服务很多，我以前从来都不爱去看。自从较用功学习易经以来，
我发现我还真的需要有个电脑起卦的程式来帮我。电脑起一卦，不用一秒钟。我起卦的心总是诚恳的，就算人在机场、捷运，把心意安定个一、两分钟我也应该做得到。如果能够有个有个我觉得**信得过**的起卦程式，那该有多好！自然，我还没有找到合用的，不然我也不会自己做一个。

要特别强调的是：这里我并没有说别家的起卦程式不好的意思，反而，有些很可能是非常好的设计。其实，大概是我自己的职业病吧：我不了解、也无从得知人家是怎么做的，因而信不过。换句话说，就是没有「孚」，于是自然对我个人不「亨」。

我个人是学习电脑工程出身，又在高科技产业打滚大半辈子，我理解真正的随机乱数产生不易。
既然决定自己写一个起卦程式，我首先花了点时间设计了一个加入多项起卦人因子的「大概够随机」的乱数算法，
再模拟人手操作大衍占法的动作，做出了这个电脑起卦程式。经过了好几次更改、调整参数，
电脑模拟计算数百万次，确定各爻出现的机率接近理论值，各卦的出现也都成合理分布，也就是现在的这个版本（2021v005）。
下图是 2021v005 模拟计算 200000 次的结果统计：

<img class="yao-stat" src="./images/autoqi_v005.png" alt="qua stat" />

在我确定模拟计算结果稳定、而且统计分布合理可接受之后，我用它自动起了一卦，得【火天大有】4 爻动：【九四】：匪其彭，无咎。
【象】：匪其彭，无咎，明辨皙也。看来好像还行，我对它有了初步的信心。既然在技术方面确定了随机合理分布，
我想，剩下的变数大概就是起卦人本身在起卦时的心意了。

第二天一大早，趁著家人还没起床，在餐桌上，我自己又用传统大衍占法，问：
「XiYi
自动起卦版本 2021v005 占卦的结果品质可信吗？」，得不变的【水地比】，卦辞：吉，原筮，元永贞，无咎。不宁方来，后夫凶。
我感到非常惊讶和有趣！除了【比卦】六爻全变就正好是昨晚自动起卦得到的【火天大有】，而易经 64 卦里又只有【山水蒙】和【水地比】两卦提到「筮」。
看来要把握初心真实诚恳为要，于是我的信心更为增加。

用了一阵子之后，得到许多惊喜，我觉得这的确是可以帮助我学习易经的工具。
当然，这是我个人的经验，现在，我对它有「孚」。欢迎您试试，看合不合您使用？也再度提醒您：千万不要迷信！

{/if}

<style>
    p {
    font-size: 16px;
  }
    li {
    font-size: 16px;
  }
    ul li {
    margin-left: 40px;
    list-style-type: square !important;
  }
  .yao-stat {
    width: 100%;
  }
</style>
